<script setup lang="ts">
import { iSelect } from '@inscribe/signal';
import { InsightConditionType } from '@/types/decision-engine/configurable-insights.types';

interface Props {
  modelValue: InsightConditionType;
}

interface Emits {
  (e: 'update:modelValue', value: InsightConditionType): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();

const options = [
  {
    value: InsightConditionType.TRANSACTIONS,
    text: 'Transaction',
  },
  {
    value: InsightConditionType.DAILY_BALANCE,
    text: 'Daily Balance',
  },
];

const onSelect = (value: InsightConditionType) => {
  emit('update:modelValue', value);
};
</script>

<template>
  <i-select
    :model-value="modelValue"
    :options="options"
    placeholder="Select type"
    data-testid="condition-type-selector"
    data-dd-action-name="condition-type-selector"
    @update:model-value="onSelect"
  />
</template>
